import React, {useEffect, useState} from 'react';
import NumberText from "../../number_text/NumberText";
import arrow from '../../../assets/icons/arrow.png';
import {useDispatch, useSelector} from "react-redux";
import {setFormName} from "../../../store/slices/formNameSlice";
import getIcon from "../../../utils/Icon";
import Avatar from "../../avatar/Avatar";
import {addMultipleTasks, addTask, clearTasks, removeTask} from "../../../store/slices/taskSlice";
import taskApi from "../../../api/taskApi";
import {message} from "antd";

export default function Tasks() {

    const tasks = useSelector((state)=> state.tasks.tasks);
    const allTasks = useSelector((state)=> state.tasks)
    const promoForm = useSelector((state)=> state.promoForm)
    const tasksService = taskApi;
    const getTasks = async () => {
        try {
            const tasks = await tasksService.getTaskById(promoForm.id);
            console.log("Полученные задачи:", tasks);
            message.success('Success: Loaded all tasks');
            dispatch(clearTasks());
            dispatch(addMultipleTasks(tasks));
        } catch (error) {
            console.error('Error fetching tasks:', error);
            message.error('Some error occurred when getting tasks');
        }
    };
    const uploadTasks = async ()=>{
        try {
            console.log(allTasks)
            const response = await tasksService.createTaskById(promoForm.id,allTasks)
            console.log(response)
            message.success('Success: added all tasks');
        } catch (e){
            console.log(e)
            message.error('Some error occurred when add tasks');
        }
    }
    // const [tasks, setTasks] = useState([]);
    const [taskType, setTaskType] = useState('');
    const [taskLink, setTaskLink] = useState('');
    const handleAddTask = () => {
        if (!taskType || !taskLink) return;

        dispatch(addTask({
            title: taskType.replace('_', ' '),
            details: taskLink // Заменили "link" на "details"
        }));

        setTaskType('');
        setTaskLink('');
        console.log(taskType);
    };

    const handleRemoveTask = (title) => {
        dispatch(removeTask(title));
    };

    const dispatch = useDispatch();
    const name = 'tasks';
    const [title, setTitle] = useState('');

    const line = () => <div className={'w-full h-[1px] bg-line'}/>

    const item = (icon, text,label) => <div className={'w-[60px] h-[60px] flex flex-col items-center  gap-1'}>
        <Avatar width={40} height={40} icon={getIcon(icon)} label={label}/>
        <p className={'text-accent text-[10px] text-thin text-center'}>{text}</p>
    </div>
    useEffect(()=>{
        getTasks()
        console.log(tasks)
    },[])

    const taskItem = ({logo,text,mini,label,btn})=><div className={'w-full h-fit flex flex-col items-center cursor-pointer'}>
            <div className={'flex flex-row items-center justify-start w-full p-2 gap-4'}>
                <Avatar icon={logo} width={35} height={35} label={label}/>
                <div className={'flex flex-col gap-0'}>
                    <p className={'text-white'}>{text}</p>
                    <p className={'text-accent text-[9px]'}>{mini}</p>
                </div>
                {btn &&
                <div className={'w-fit h-[30px]  flex items-center justify-center bg-myblue rounded-md p-4 ml-auto'}>
                 <p className={'text-white font-semi text-[14px]'}>   {btn}</p>
                </div>
                }
            </div>
        </div>


    const sp_button =(text,active)=><div className={'w-[85px] h-[30px] bg-[#121212] border border-[#3B3B3B] rounded-md flex justify-center items-center  items-center '}>
       <p className={`${active ? 'text-white':'text-accent'} text-[10px] text-center`}>{text}</p>
    </div>

    return (
        <div className={'flex flex-col items-center w-full cursor-pointer bg-black p-1 rounded-md border border-white/20'}>


            <div className={'flex flex-col items-center w-full h-fit  border-border_square '}>

                <div
                    className={'w-full flex flex-row flex-wrap items-center justify-start xs:gap-2  xs:pl-2  gap-3 pl-4 pr-4 xs:pr-2'}>

                </div>
                {line()}

                {line()}
                <div className={'h-[30px] w-full'}/>
                {line()}
                {/*<div  className={'w-full flex flex-col pt-4'} >*/}
                {/*    <p className={'text-accent text-[7px] ml-12'}>one sponsor/promoter = 7 tasks</p>*/}
                {/*    <div className={'flex flex-row w-full justify-center gap-6 mb-2'}>*/}
                {/*        {sp_button('Neiro')}*/}
                {/*        {sp_button('2 sponsor')}*/}
                {/*        {sp_button('3 sponsor')}*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div
                    className={'w-full flex flex-row flex-wrap items-center justify-start xs:gap-2  xs:pl-2  gap-3 pl-4 pr-4 xs:pr-2'}>
                    <div className={'w-full flex flex-row justify-between mt-2 mb-2'}>
                        <p className={'text-[12px] text-accent'}> social media</p>
                        <img src={getIcon('inc')} className={'w-[15px] h-[15px]'}/>
                    </div>
                </div>

                {line()}
                {taskItem({logo:getIcon('logo'),text:'Follow Octo channel', mini:'default',btn:'Yes',label:'telegram'})}
                {line()}
                <div className={'w-full flex flex-col items-center'}>
                    {tasks.length > 0 ? (
                        tasks.map((task, index) => (
                            <div key={index} className={'w-full h-fit flex flex-col items-center cursor-pointer'}>
                                <div className={'flex flex-row items-center justify-start w-full p-2 gap-4'}>
                                    <Avatar icon={task.logo} width={35} height={35} label={task.title} />
                                    <div className={'flex flex-col gap-0'}>
                                        <p className={'text-white'}>{task.title}</p>
                                        <p className={'text-accent text-[9px]'}>{task.mini}</p>
                                    </div>
                                    <a href={task.details} target="_blank" rel="noopener noreferrer" className="text-blue-400 ml-auto">
                                        Открыть
                                    </a>
                                    <button className="text-red-500 text-sm ml-2" onClick={() => handleRemoveTask(task.title)}>✖</button>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className={'text-accent font-thin text-[10px]'}>Нет добавленных задач</p>
                    )}
                </div>


                <div className={'w-full flex flex-col items-center p-4'}>
                    <p className={'text-accent text-[12px]'}>Добавить новую задачу</p>

                    {/* Выбор типа задачи */}
                    <div className="relative w-[90%]">
                        <select
                            className="w-full p-3 border border-gray-600 rounded-lg bg-gray-900 text-white text-sm outline-none transition-all focus:ring-2 focus:ring-myblue cursor-pointer appearance-none"
                            value={taskType}
                            onChange={(e) => setTaskType(e.target.value)}
                        >
                            <option value="">Выбрать тип задачи</option>
                            <option value="twitter">🔹 Подписка на Twitter</option>
                            <option value="telegram">🔹 Подписка на Telegram</option>
                            <option value="youtube_sub">🔹 Подписка на YouTube</option>
                            <option value="youtube_video">🔹 Посмотреть видео</option>
                            <option value="youtube_bell">🔹 Включить колокольчик</option>
                            <option value="instagram">🔹 Подписка на Instagram</option>
                            <option value="youtube_sub">🔹 Перейти по ссылке</option>
                        </select>
                        <div className="absolute right-3 top-[50%] translate-y-[-50%] text-gray-400 pointer-events-none">
                            ▼
                        </div>
                    </div>

                    {/* Ввод ссылки */}
                    <input
                        type="text"
                        className="w-[90%] p-3 border border-gray-600 rounded-lg bg-gray-900 text-white text-sm outline-none transition-all focus:ring-2 focus:ring-myblue mt-2 placeholder-gray-400"
                        placeholder="🔗 Вставьте ссылку"
                        value={taskLink}
                        onChange={(e) => setTaskLink(e.target.value)}
                    />


                    {/* Кнопка добавления */}
                    <div onClick={handleAddTask} className={'flex flex-col items-center  w-full'}>
                        <span className={'text-line font-thin text-[35px]'}>+</span>
                        <p className={'text-accent font-thin text-[10px]'}>add new task for promo</p>
                    </div>
                </div>

            <div onClick={uploadTasks} className={'w-full h-[30px] text-black items-center text-center flex justify-center cursor-pointer rounded-md bg-lime-400'}>
                    Confirm
            </div>

                <div
                    className={'w-full flex flex-row flex-wrap items-center justify-start xs:gap-2  xs:pl-2  gap-3 pl-4 pr-4 xs:pr-2'}>
                    <div className={'w-full flex flex-row justify-between mt-2 mb-2'}>
                        <p className={'text-[12px] text-accent'}> advanced</p>
                        <img src={getIcon('inc')} className={'w-[15px] h-[15px]'}/>
                    </div>
                </div>
                {line()}
                {taskItem({logo:getIcon('friend'),text:'Invite friend', mini:'one sponsor/promoter = one channel',btn:'Done'})}
            </div>

        </div>
    );
}
